import { API_URL } from './environment';
import GlobalStatistics from './model/GlobalStatistics';
import SubscriberData from './model/SubscriberData';
import fetcher from './utils/fetcher';

export const addToUserCompanies = async (userId: string, companyKey: string): Promise<Response> => {
  return fetcher(`${API_URL}/v1/admin/user/${userId}/companies/${companyKey}`, {
    method: 'PUT',
  });
};

export const removeFromUserCompanies = async (
  userId: string,
  companyKey: string,
): Promise<Response> => {
  return fetcher(`${API_URL}/v1/admin/user/${userId}/companies/${companyKey}`, {
    method: 'DELETE',
  });
};

export const getGlobalStats = async (month: number, year: number): Promise<GlobalStatistics> => {
  return fetcher(`${API_URL}/v1/admin/statistics?month=${month}&year=${year}`);
};

export const getLastSubscriberCount = async (
  date: string,
): Promise<{
  subscriptionStats: SubscriberData;
}> => {
  return fetcher(`${API_URL}/v1/admin/statistics/date/${date}`);
};

export const addToResellerCompanies = async (
  resellerId: string,
  companyKey: string,
): Promise<Response> => {
  return fetcher(`${API_URL}/v1/reseller/${resellerId}/companies/${companyKey}`, {
    method: 'PUT',
  });
};
export const removeFromResellerCompanies = async (
  resellerId: string,
  companyKey: string,
): Promise<Response> => {
  return fetcher(`${API_URL}/v1/reseller/${resellerId}/companies/${companyKey}`, {
    method: 'DELETE',
  });
};
